// This utils module will likely export more functions later,
// to avoid having to rewrite import code, disable this rule.
// eslint-disable-next-line import/prefer-default-export
export const isProd = process.env.REACT_APP_STAGE === 'prod' || process.env.REACT_APP_STAGE === 'prod-devnet';

export const isProdMainnet = process.env.REACT_APP_STAGE === 'prod';

export const isUniquenessPortal = (): boolean => process.env.REACT_APP_PASS_TYPE === 'uniqueness';
